import { Funnel } from 'lucide-react'
import { Chart, Separator as TWSeparator, Button, DefaultTooltip } from 'twyne-new.ui'

import { useGrid } from '@Components/Grid/context';

import DefaultActions from './Actions';
import Search from './Search'
import TableColumns from './TableColumns'
import Wrapper from './Wrapper';

export { Search, Wrapper, DefaultActions }

export default function DefaultHeading({ children = <DefaultActions /> }) {
  return <Wrapper>
    <Search />
    <Separator />
    <GridToggles />
    <Separator />
    <Total />
    <Showing />
    <Active />
    <Separator />
    {children}
  </Wrapper>
}

export function Total() {
  const { store: { collections: { total } } } = useGrid()
  return <ResponsiveChart text='Total' value={total} />
}

export function Showing() {
  const { store: { collections: { items, total } } } = useGrid()
  return <ResponsiveChart text='Showing' value={items.length} total={total} color='warning' />
}

export function Active() {
  const { store: { collections: { actives, total } } } = useGrid()
  return <ResponsiveChart text='Active' value={actives} total={total} color='success' />
}

export function Separator() {
  return <TWSeparator orientation='vertical' className='py-5 max-md:[.grid-counter+&]:hidden' />
}

function ResponsiveChart(props) {
  return <Chart {...props} className='grid-counter hidden md:flex' />
}

export function GridToggles() {
  return <div className='flex gap-2'>
    <ToggleFilters />
    <TableColumns />
  </div>
}

function ToggleFilters() {
  const { filters } = useGrid()
  const { showFilters, setShowFilters } = useGrid()

  if (!filters || filters.length === 0) {
    return null
  }

  return <DefaultTooltip content={showFilters ? 'Hide filters' : 'Show filters'} side='bottom'>
    <Button variant='outline' color={showFilters ? 'accent' : 'neutral'} onClick={() => setShowFilters(show => !show)}>
      <Funnel size='14' />
    </Button>
  </DefaultTooltip>
}
